import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    Box,
    Button,
    FormGroup,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Tooltip,
    FormControlLabel,
    Checkbox,
    Link as LinkComponent,
} from "@mui/material";
import {Link} from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import organisationActions from '../../../store/organisation/actions';
import {selectUserOrganisation} from '../../../store/user/selectors';
import {IOrganisation} from '../../../common/organisation';
import { createOrganisationLink } from '../../../utils';

type Props = {
    organisation: IOrganisation;
    changeOrganisationSettings: Function;
}
const View = ({
    organisation,
    changeOrganisationSettings,
}: Props) => {
    const [organisationName, setOrganisationName] = useState<string | null>();
    const [organisationLink, setOrganisationLink] = useState<string>();
    const saveLinkToBuffer = () => {
        navigator.clipboard.writeText(String(organisationLink));
    };
    const saveOrganisationName = () => {
        if (organisation.alias) {
            changeOrganisationSettings({
                name: organisationName,
                alias: organisation.alias,
            });
        }
        setOrganisationName(null);
    };
    const changeReportSettings = (isEnabled: boolean, setting: 'daily' | 'weekly') => {
        const field = setting == 'daily' ? 'sendDaily' : 'sendWeekly';
        if (organisation.alias) {
            changeOrganisationSettings({ 
                alias: organisation.alias,
                reportSettings: {[field]: isEnabled},
            });
        }
    };
    useEffect(() => {
        if (organisationLink || !organisation?.alias) {
            return;
        }
        //@ts-expect-error
        const createLinkFn = createOrganisationLink[organisation.alias];
        if (!createLinkFn) {
            return;
        }
        setOrganisationLink(createLinkFn());
    }, [organisation]);
    return (
        <Paper sx={{p: 2}}>
            <Typography
                component='h1'
                sx={{
                    fontWeight: 'bold',
                    fontSize: '2rem',
                    color: '#507ebc',
                }}
            >
                Общие настройки
            </Typography>
            <FormGroup sx={{
                mb: 2,
                py: 2,
                display: 'grid',
                gridTemplateColumns: '1fr 150px',
                gap: '20px',
            }}>
                <TextField
                    id="organisationName"
                    label="Название организации"
                    variant="outlined"
                    onChange={e => setOrganisationName(e.target.value)}
                />
                <Button variant="contained" disabled={!organisationName} onClick={saveOrganisationName}>Сохранить</Button>
            </FormGroup>
            {organisationLink && (
                <Box>
                    <Typography
                        component='h2'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1.4rem',
                            color: '#507ebc',
                        }}
                    >
                        Ссылка для входа
                    </Typography>
                    <FormGroup sx={{
                        mb: 2,
                        py: 2,
                        display: {sm: 'grid'},
                        gridTemplateColumns: '1fr 150px',
                        gap: '20px',
                    }}>
                    
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'flexStart', width: '100%', overflow: 'hidden'}}>
                        <LinkComponent
                            component={Link}
                            to={organisationLink}
                        >
                            {organisationLink}
                        </LinkComponent>
                        <IconButton color='primary' size='large' onClick={() => saveLinkToBuffer()}>
                            <ContentCopyIcon color='primary' />
                        </IconButton>
                    </Box>
                    </FormGroup>
                </Box>
            )}
            <Typography
                component='h2'
                sx={{
                    fontWeight: 'bold',
                    fontSize: '1.4rem',
                    color: '#507ebc',
                }}
            >
                Настройки отчетов
            </Typography>
            <FormGroup>
                <FormControlLabel control={<Checkbox defaultChecked={organisation?.reportSettings?.sendWeekly} onChange={e => {changeReportSettings(e.target.checked, 'weekly')}} />} label="Присылать еженедельный отчет" />
                <FormControlLabel control={<Checkbox  defaultChecked={organisation?.reportSettings?.sendDaily} onChange={e => {changeReportSettings(e.target.checked, 'daily')}} />} label="Присылать ежедневный отчет" />
            </FormGroup>
            {organisation && (
                <Box sx={{my: 2}}>
                    <Typography
                        component='h3'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem', 
                        }}
                    >
                        Тарифный план: <Typography component='span' sx={{color: '#507ebc'}}>{organisation.subscription.name}</Typography>
                    </Typography>
                    <Typography
                        component='h3'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem', 
                        }}
                    >
                        Максимальное количество пользователей: <Typography component='span' sx={{color: '#507ebc'}}>{organisation.subscription.maxUsers}</Typography>
                    </Typography>
                    <Typography
                        component='h3'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem', 
                        }}
                    >
                        Максимальное количество курсов: <Typography component='span' sx={{color: '#507ebc'}}>{organisation.subscription.maxGroups}</Typography>
                    </Typography>
                </Box>
        )}
        </Paper>
    )
}

//@ts-expect-error
const mapStateToProps = (state) => ({
    organisation: selectUserOrganisation(state),
    // rootGroup: selectRootGroup(state),
})

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    changeOrganisationSettings: bindActionCreators(organisationActions.changeOrganisationSettings, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);
